import { ChartComponent } from './chart.component';
import { TransformData } from './TransformData';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxEchartsModule } from 'ngx-echarts';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

const DECLARATIONS = [ChartComponent, TransformData];
const IMPORTS = [MatButtonModule, MatIconModule, CommonModule];
const ENTRY_POINTS = [];

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [
    ...IMPORTS,
    NgxEchartsModule.forRoot({
      echarts: () => import('./echarts-custom').then((m) => m.default),
    }),
  ],
  exports: [...DECLARATIONS, ...IMPORTS],
})
export class ChartModule {}
